import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import Swal from 'sweetalert2'
import ReactPaginate from 'react-paginate'
import Loader from 'react-js-loader'
import loader from '../loder.gif'
import { Link } from 'react-router-dom'
import admindata from '../../components/admindata'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { apiRequest } from '../../apiServices/allApi'
const $ = require('jquery')
$.Datatable = require('datatables.net')

const Transactionhistory = () => {
  const Userid = localStorage.getItem('id')
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState()
  console.log(user)
  const [allDeposite, SetallDeposite] = useState()


  //use for pagination..
  let [limit, setLimit] = useState(20)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)

  //user for searching..
  const [searchList, setSearchList] = useState(0)
  const [searchType, setSearchType] = useState("Phone")
  const [findByStatus, setFindByStatus] = useState(0)

  //   searching handler
  const searchHandler = event => {
    let key = event.target.value

    setSearchList(key)
  }
  //   search by status handler
  const searchByStatus = event => {
    setSearchType("0")
    let key = event.target.value
    setFindByStatus(key)
  }

  //react paginate..
  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
    // scroll to the top
    //window.scrollTo(0, 0)
  }


  const profle = async () => {

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`admin/get_txn_deposit/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}`, "GET", null, headers);
      // setUser(res.data.admin)
      // setNumberOfPages(res.data.totalPages)
      const filteredData = res.data.admin.filter(
        item => item.status === "PAID" || item.status === "FAILED"
      );

      setUser(filteredData);
      setNumberOfPages(res.data.totalPages);
    } catch (error) {
      setLoading(false)
    } finally {
      // setLoading(false)
    }
  }

  const checkdeposit = async (order_id, order_token, pay_date) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`depositupipay/response`, "POST",
        { order_id, order_token, pay_date }, headers)
      const icon = res.data.status == 'PAID' ? 'success' : 'danger'
      const title =
        res.status == 'PAID'
          ? 'Deposit submited successfully'
          : 'Transaction Failed'
      profle()

    } catch (e) {
      setLoading(false)
      if (e.response.status == 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('token')
        window.location.reload()
      }

    } finally {
      // setLoading(false)
    }
  }

  const cash_free_deposit = async (order_id, order_token) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`deposit/response`, "POST",
        { order_id, order_token }, headers)
      const icon = res.data.status == 'PAID' ? 'success' : 'danger'
      const title =
        res.status == 'PAID'
          ? 'Deposit submited successfully'
          : 'Transaction Failed'
      profle()

    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('token')
        window.location.reload()
      }

    } finally {
      // setLoading(false)
    }
  }

  const phone_deposit = async (order_id, order_token) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`phonpay-request-status?txnId=${order_id}`, "GET", null, headers);
      console.log(res, 'res.data')
      const icon = res.data.status == 'PAID' ? 'success' : 'danger'
      const title =
        res.status == 'PAID'
          ? 'Deposit submited successfully'
          : 'Transaction Failed'
      profle()
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('token')
        window.location.reload()
      }
    } finally {
      // setLoading(false)
    }
  }

  const universalCheckDeposit = (payment_gatway, order_id, order_token, pay_date, _id, refId) => {
    // alert(payment_gatway);
    console.log(order_id)
    if (payment_gatway == 'razorpay') {
      checkrazorpayPayment(order_id, order_token, pay_date)
    }
    else if (payment_gatway == 'CAMLPAY') {
      checkCamlPay(refId)
    }

    else if (payment_gatway == 'Upigatway') {
      checkupigatewaypay(order_id, order_token, pay_date)
    }
    else if (payment_gatway == 'ZAPGATEWAY') {
      checkZAP(order_id, order_token, pay_date)
    }
    else if (payment_gatway == 'PGATEWAY') {
      checkpggatewaypay(order_id, order_token, pay_date)
    }
    else if (!payment_gatway) {
      alert(payment_gatway)
      withdrowFail(order_id)
    } else {
      alert('Nothing found');
    }
  }


  const checkrazorpayPayment = async (order_id, order_token) => {
    setLoading(true)
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`razorpaycheck/response`, "POST",
        { order_id, order_token }, headers)
      setLoading(false)
      const icon = res.data.status == 'PAID' ? 'success' : 'danger'
      const title =
        res.status == 'PAID'
          ? 'Deposit submited successfully'
          : 'Transaction Failed'
      profle()
    } catch (e) {
      setLoading(false)
      if (e.response.status == 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('token')
        window.location.reload()
      }

    } finally {
      // setLoading(false)
    }
  }


  const checkCamlPay = async (_id) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`camlenio-deposit-status?ExternalId=${_id}`, "GET", null, headers);
      profle()
      Swal.fire({
        title: res.data.message,
        icon: 'success',
        confirmButtonText: 'OK'
      })
    } catch (e) {
      Swal.fire({
        title: e.msg,
        icon: 'error',
        confirmButtonText: 'OK'
      })
    } finally {
      // setLoading(false)
    }
  }

  const haodapay = async (order_id, order_token, pay_date) => {
    alert(order_id)
    setLoading(true)

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`haodapay-request-status?txnId=` + order_id, { order_id, order_token }, "GET", null, headers);
      setLoading(false)
      const icon = res.data.status == 'PAID' ? 'success' : 'danger'
      const title =
        res.status == 'PAID'
          ? 'Deposit submited successfully'
          : 'Transaction Failed'
      profle()
    } catch (e) {
      setLoading(false)
      if (e.response.status == 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('token')
        window.location.reload()
      }
    } finally {
      // setLoading(false)
    }
  }

  const checkupigatewaypay = async (order_id, order_token, pay_date) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`depositupipay/check_status`, "POST", { order_id, order_token }, headers);
      const icon = res.data.status == "PAID" ? "success" : "danger";
      Swal.fire({
        text: res.data?.msg,
        icon: "success"
      });
      profle();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };
  const checkpggatewaypay = async (order_id, order_token, pay_date) => {
    setLoading(true)

    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    try {
      const res = await apiRequest(`pg-upigateway/check_status`, "POST", { order_id }, headers);
      setLoading(false)
      setLoading(false)

      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title = res.data.status == "PAID" ? "Deposit submited successfully" : "Transaction Failed";
      profle();
    } catch (e) {
      setLoading(false)
      if (e.response.status == 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('token');
        window.location.reload()
      }
    } finally {
      // setLoading(false)
    }
  }
  const checkZAP = async (order_id, order_token, pay_date) => {
    setLoading(true)

    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    try {
      const res = await apiRequest(`zap-upigateway/check_status`, "POST", { order_id }, headers);
      setLoading(false)
      setLoading(false)

      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title = res.data.status == "PAID" ? "Deposit submited successfully" : "Transaction Failed";
      profle();
    } catch (e) {
      setLoading(false)
      if (e.response.status == 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('token');
        window.location.reload()
      }
    } finally {
      // setLoading(false)
    }
  }


  const checkupigatewayphonepe = async (order_id, order_token, pay_date) => {
    setLoading(true)
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`phonpay-request-status?txnId=${order_id}`, "GET", null, headers);
      setLoading(false)
      // console.log(res, 'res.data')
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title = res.data.status == "PAID" ? "Deposit submited successfully" : "Transaction Failed";
      profle();
    } catch (e) {
      if (e.response.status == 401) {
        setLoading(false)
        localStorage.removeItem('token');
        localStorage.removeItem('token');
        window.location.reload()
      }
    } finally {
      // setLoading(false)
    }
  }

  const checkPinelabpay = async (order_id, order_token, pay_date) => {
    setLoading(true)
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`pinelabdesposit/response`,
        { order_id, order_token }, "POST", headers);

      setLoading(false)
      const icon = res.data.status == 'PAID' ? 'success' : 'danger'
      const title =
        res.status == 'PAID'
          ? 'Deposit submited successfully'
          : 'Transaction Failed'
      profle()
    } catch (e) {
      setLoading(false)
      if (e.response.status == 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('token')
        window.location.reload()
      }
    } finally {
      // setLoading(false)
    }
  }


  const withdrowPass = async (id) => {
    const confirm = window.confirm(
      'Are you sure, you want to update to success this deposit?'
    )
    if (confirm) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }
      try {
        const res = await apiRequest(`userdipositupdate/${id}`,
          {
            status: 'SUCCESS'
          }, "POST", headers);
        profle()
        alert('deposit successfully done')
      } catch (e) {
        //console.log(e);
      } finally {
        // setLoading(false)
      }
    }
  }

  const withdrowFail = async (order_id) => {
    const confirm = window.confirm(
      'Are you sure, you want to update to failed this deposit?'
    )
    if (confirm) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }

      try {
        const res = await apiRequest(`userdipositupdate/${order_id}`,
          {
            status: 'FAILED'
          }, "POST", headers);
        profle()
        alert('deposit successfully reject')
      } catch (e) {
        //console.log(e);
      } finally {
        // setLoading(false)
      }
    }
  }

  // check in

  const dateFormat = e => {
    const date = new Date(e)
    const newDate = date.toLocaleString('default', {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
      minute: 'numeric'
    })
    return newDate
  }

  const newdateFormat = e => {
    let today = new Date(e)
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    return today
  }

  useEffect(() => {
    profle()
  }, [pageNumber, limit, searchList, searchType, findByStatus])

  if (user == undefined) {
    return null
  }

  const Invoice = data => {
    const userData = { data }
    // setUser(userData);
    console.log(userData)
    history.push('/invoice', { userData })
  }

  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={<img src={loader} alt='Loading...' />}
            color={'#000'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card '>
            <div className='card-body text-light table_bg'>
              <h4 className='dashboard_heading'>Deposit History</h4>

              {/* searching */}
              <div className='row'>
                <select
                  className='form-control col-sm-3 m-2'
                  id='searchType'
                  name='searchtype'
                  onChange={e => setSearchType(e.target.value)}
                >
                  <option value='Phone'>Phone</option>

                  <option value='Name'>Name</option>
                  <option value='Phone'>Phone</option>
                  <option value='_id'>TxnId</option>
                </select>
                <input
                  type='text'
                  placeholder='Search...'
                  className='form-control col-sm-4 m-2'
                  onChange={searchHandler}
                />
                <h5>Or</h5>
                <select
                  className='form-control col-sm-3 m-2'
                  id='findByStatus'
                  name='findByStatus'
                  onChange={searchByStatus}
                >
                  <option value='0'>Search Status</option>
                  <option value='FAILED'>FAILED</option>
                  <option value='Pending'>Pending</option>
                  <option value='pending'>pending</option>
                  <option value='PAID'>PAID</option>
                  <option value='pending'>pending</option>
                  <option value='checkin'>Checkin</option>
                </select>
                <select
                  className='form-control col-sm-1 m-1 bg-dark text-light'
                  id='pagelimit'
                  name='pagelimit'
                  onChange={setpageLimit}
                >
                  <option value='10'>Set limit</option>
                  <option value='20'>20</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                  <option value='500'>500</option>
                </select>
              </div>

              <div className='table-responsive'>
                <table className='table text-light'>
                  <thead>
                    <tr>
                      <th>#</th>

                      <th> ID</th>
                      <th> Order Token</th>
                      <th> Phone</th>
                      <th> User</th>

                      <th> Amount </th>
                      <th> Status </th>
                      <th> ----- </th>
                      <th> Date </th>
                      <th> Action By </th>
                      <th> Action </th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* {user &&
                      user.map((data, key) => { */}
                      {user &&
  user
    .filter(
      data =>
        data.status === "PAID" ||
        data.status === "FAILED"
    )
    .map((data, key) => {
                        var id = data._id.toString(),
                          ctr = 0
                        var timestamp = id.slice(ctr, (ctr += 8))
                        var machineID = id.slice(ctr, (ctr += 6))
                        var processID = id.slice(ctr, (ctr += 4))
                        var counter = id.slice(ctr, (ctr += 6))
                        //console.log("id:", id);
                        //console.log("timestamp:", parseInt(timestamp, 16));
                        //console.log("machineID:", parseInt(machineID, 16));
                        //console.log("processID:", parseInt(processID, 16));
                        var counterid = parseInt(timestamp, 16)
                        let currentTime = Date.now()
                        let gameCreatedAt = new Date(data.createdAt).getTime()

                        return (
                          <tr>
                            <td>{key + 1}</td>

                            <td
                              style={{
                                color:
                                  data.payment_gatway === 'phonepe'
                                    ? 'red'
                                    : 'black'
                              }}
                            >
                              {data.payment_gatway === 'phonepe' ? (
                                <span>
                                  {data.payment_gatway}-{data._id}
                                  <br />
                                  Order ID: {data?.order_id}
                                </span>
                              ) : (
                                data._id
                              )}
                            </td>
                            <td>
                              {data.order_token}

                            </td>
                            <td>
                              {admindata?.user?.usertype == 'Admin' ||
                                admindata?.user?.updateLegalData === true ? (
                                <span className='pl-2'>
                                  {data.User_id ? data.User_id.Phone : ''}
                                </span>
                              ) : (
                                <span className='pl-2'>{`${'********' +
                                  data.User_id.Phone.toString().slice(-2)
                                  }`}</span>
                              )}
                            </td>
                            <td>
                              {data.User_id && (
                                <Link
                                  className='btn btn-sm btn-outline-info'
                                  to={`/user/view_user/${data.User_id._id}`}
                                >
                                  {data.User_id.Name}
                                </Link>
                              )}
                            </td>


                            <td>{data.amount}</td>
                            <td className='font-weight-bold text-success'>
                              {data.status}
                            </td>


                            <td>
                              {
                                //&& (parseInt(gameCreatedAt) + 7200000) < currentTime
                                (data.status != 'PAID' && data.status != 'SUCCESS' && data.status != 'FAILED') ? <button className="btn btn-danger" onClick={() => universalCheckDeposit(data.payment_gatway, data.order_id, data.order_token, newdateFormat(data.createdAt), data._id, data?.referenceId)} >Check {data.payment_gatway}</button> : "Checked All "
                              }


                              {
                                //   <button className="ml-1 btn btn-sm btn-warning" onClick={() => withdrowPass(data._id)}>Success</button>
                              }
                            </td>
                            <td>{dateFormat(data.createdAt).split(',')[0]} </td>
                            <td className='font-weight-bold text-success'>
                              {data?.action_by?.Name ?? "----"}
                            </td>
                            <td>
                              <button
                                className='btn btn-primary'
                                onClick={() => Invoice(data)}
                              >
                                View
                              </button>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>

              <div className='mt-4'>
                <ReactPaginate
                  previousLabel={'Previous'}
                  nextLabel={'Next'}
                  breakLabel={'...'}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination justify-content-center'}
                  pageClassName={'page-item'}
                  pageLinkClassName={'page-link'}
                  previousClassName={'page-item'}
                  previousLinkClassName={'page-link'}
                  nextClassName={'page-item'}
                  nextLinkClassName={'page-link'}
                  breakClassName={'page-item'}
                  breakLinkClassName={'page-link'}
                  activeClassName={'active'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Transactionhistory
